import React from "react";
import {
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Table,
    Grid,
    Typography,
    Box,
    makeStyles,
    TableContainer
} from '@material-ui/core';
 
const useStyles = makeStyles((theme) => ({
    page: {
        padding: '40px',
        backgroundColor: '#ffffff',
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    },
    header: {
        marginBottom: '30px',
        borderBottom: '3px solid #000000',
        paddingBottom: '20px',
    },
    companyName: {
        fontSize: '28px',
        fontWeight: 700,
        color: '#000000',
        marginBottom: '8px',
        textTransform: 'uppercase',
        textAlign: 'left',
    },
    documentTitle: {
        fontSize: '24px',
        fontWeight: 600,
        color: '#000000',
        marginTop: '10px',
        letterSpacing: '2px',
        textAlign: 'center',
    },
    documentSubtittle: {
        fontSize: '15px',
        fontWeight: 400,
        color: '#000000',
        marginTop: '5px',
        letterSpacing: '1px',
        textAlign: 'center',
        lineHeight: '12px',
    },
    sectionTitle: {
        fontSize: '14px',
        fontWeight: 700,
        color: '#000000',
        marginBottom: '12px',
        // marginTop: '8px',
        textTransform: 'uppercase',
        borderBottom: '1px solid #000000',
        paddingBottom: '6px', 
    },
    infoBox: {
        padding: '10px',
        marginBottom: '13px',
        border: '1px solid #000000', 
        width: '300px',        
        height: '200px',    
    },

    infoRow: {
        display: 'flex',
        marginBottom: '3px',
        // borderBottom: '1px solid #cccccc',
        paddingBottom: '3px',
        '&:last-child': {
            marginBottom: 0,
            borderBottom: 'none',
        },
    },
    
    infoLabel: {
        fontWeight: 700,
        minWidth: '140px',
        color: '#000000',
        fontSize: '11px',
        //border: '1px solid #000000',
    },
    infoValue: {
        color: '#424242',
        fontSize: '11px',
    },
    table: {
        marginTop: '10px',
        border: '2px solid #000000',
    },
    tableHeaderCell: {
        fontWeight: 700,
        fontSize: '10px',
        // padding: '10px 8px',
        // border: '1px solid #000000',
        // textTransform: 'uppercase',
        borderBottom: '2px solid #000000',
    },
    tableCell: {
        fontSize: '12px',
        padding: '8px',
        // border: '1px solid #000000',
    },
    summaryBox: {
        marginTop: '30px',
        float: 'right',
        width: '350px',
        border: '3px solid #000000',
        overflow: 'hidden',
    },
    summaryRow: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '8px 12px',
        borderBottom: '1px solid #000000',
        '&:last-child': {
            borderBottom: 'none',
            borderTop: '2px solid #000000',
            fontWeight: 700,
            fontSize: '15px',
        },
        '&:first-child': {
            borderTop: 'none',
            borderBottom: '2px solid #000000',
            fontWeight: 700,
            fontSize: '15px',
        },
    },  
    summaryHeading: { 
        textTransform:'uppercase',
        fontSize: '13px', 
        textAlign: 'center',
    }, 
    summaryLabel: {
        fontWeight: 600,
        fontSize: '13px',
    },
    summaryValue: {
        fontSize: '13px',
        fontWeight: 600,
    },
    poNumberBadge: {
        // padding: '8px 16px',
        display: 'inline-block',
        fontSize: '14px',
        fontWeight: 700, 
        letterSpacing: '1px', 
    },
    dateBadge: {
        // padding: '6px 14px',
        display: 'inline-block',
        fontSize: '14px',
        color: '#000000', 
        fontWeight: 700,  
        textAlign: 'right', 
        paddingLeft: '300px',
    }, 
    signatureLine: { 
        paddingTop:'50px',
    },
    signatureText: {
        borderTop: '1px solid #000000',
        fontSize:'13px',
    },
    markBox: {
        padding: '10px',
        marginBottom: '13px',
        border: '1px solid #000000', 
        paddingTop: '20px', 
        marginTop: '20px',
        width: '200px',        
        height: '150px',       
        textAlign: 'center',
    },
    bottom: {
        borderBottom: '1px solid #000000',
        paddingTop: '15px',
        marginTop:'15px',
    },
    
}));

export default class ComponentToPrint extends React.Component {
    render() {
        const data = this.props.dpoData;
        const dpodetails = data[0];
          
        const grossTotal = data.reduce((acc, row) => {
            const quantity = row && row.requestedQuantity;
            const unitPrice = row && row.unitPrice;
            const qty = (quantity !== undefined && quantity !== null && !isNaN(Number(quantity))) ? Number(quantity) : 0;
            const price = (unitPrice !== undefined && unitPrice !== null && !isNaN(Number(unitPrice))) ? Number(unitPrice) : 0;
            return acc + (qty * price);
        }, 0);
        const totalDiscount = data.reduce((acc, row) => {
        const discountVal = row && row.discount;
        const n = (discountVal !== undefined && discountVal !== null && !isNaN(Number(discountVal))) ? Number(discountVal) : 0;
        return acc + n;
    }, 0);
      
        const vat = dpodetails.vat || 0;
        const netTotal = grossTotal -totalDiscount + vat;

        return (
            <WithStyles data={data} dpodetails={dpodetails} grossTotal={grossTotal} totaldiscount={totalDiscount} vat={vat} netTotal={netTotal} />
        );
    }
}

function WithStyles({ data, dpodetails, grossTotal,totaldiscount, vat, netTotal }) {
    const classes = useStyles();

    return (
        <div className={classes.page}> 
            <Box className={classes.header}>
                <Typography className={classes.documentTitle}>
                  DIRECT PURCHASE ORDER
                </Typography>
                 <Typography className={classes.documentSubtittle}>
                    {dpodetails.groupName}
                </Typography>
                 <Typography className={classes.documentSubtittle}>
                    {dpodetails.factoryName}
                </Typography> 
            </Box>   
            <div style={{ marginBottom: '20px' }}>
                <div className={classes.poNumberBadge}>
                    DPO No : {dpodetails.dpoNumber || dpodetails.poNumber || ''}
                </div>
                <div className={classes.dateBadge} style={{ marginLeft: '8px' }}>
                    Purchase Date: {dpodetails.orderDate ? dpodetails.orderDate.split('T')[0] : (dpodetails.purchaseDate ? dpodetails.purchaseDate.split('T')[0] : '')}
                </div>
            </div>

            
            <Grid container spacing={3}>
            
                <Grid item xs={6}> 
                    <Box className={classes.infoBox}>
                        <Typography className={classes.sectionTitle}>Supplier Information</Typography>
                        <div className={classes.infoRow}>
                            <span className={classes.infoLabel}>Supplier Name:</span> 
                            <span className={classes.infoValue}>{dpodetails.supplierName || '-'}</span>
                        </div>
                        <div className={classes.infoRow}>
                            <span className={classes.infoLabel}>Address:</span> 
                            <span className={classes.infoValue}>{dpodetails.supplierAddress || '-'}</span>
                        </div>
                        <div className={classes.infoRow}>
                            <span className={classes.infoLabel}>Tel No:</span>
                            <span className={classes.infoValue}>{dpodetails.supplierContactNo || '-'}</span>
                        </div>
                        <div className={classes.infoRow}>
                            <span className={classes.infoLabel}>VAT No:</span>
                            <span className={classes.infoValue}>{dpodetails.supplierVatNo || '-'}</span>
                        </div> 
                    </Box>
                </Grid>

                {/* Factory Information */}
                <Grid item xs={6}> 
                    <Box className={classes.infoBox}>
                        <Typography className={classes.sectionTitle}>Factory Information</Typography>
                        <div className={classes.infoRow}>
                            <span className={classes.infoLabel}>Factory:</span>
                            <span className={classes.infoValue}>Owinmo Tea Management (Pvt) Ltd </span> 
                        </div>
                        <div className={classes.infoRow}>
                            <span className={classes.infoLabel}>Address:</span>
                            <span className={classes.infoValue}>"Owinmo", Katukurundawatta, Baddegama Road, Uluvitike, Galle </span>
                        </div>
                        <div className={classes.infoRow}>
                            <span className={classes.infoLabel}>Mobile No:</span>
                            <span className={classes.infoValue}>077 3131531/0777 347765</span>
                        </div>
                        <div className={classes.infoRow}>
                            <span className={classes.infoLabel}>Email:</span>
                            <span className={classes.infoValue}>finance@owinmo.lk </span>
                        </div> 
                        <div className={classes.infoRow}>
                            <span className={classes.infoLabel}>Factory VAT No:</span>
                            <span className={classes.infoValue}>107009132-7000 </span> 
                        </div> 
                    </Box>
                </Grid>
            </Grid>

            {/* Order Details */}
            <Typography className={classes.sectionTitle}>Order Details</Typography>
            <TableContainer className={classes.table}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.tableHeaderCell}>SKU Code</TableCell>
                            <TableCell className={classes.tableHeaderCell}>SKU Category</TableCell>
                            <TableCell className={classes.tableHeaderCell}>SKU Name</TableCell>  
                            <TableCell className={classes.tableHeaderCell} align="right">Quantity</TableCell>
                            <TableCell className={classes.tableHeaderCell} align="right">Unit Price</TableCell> 
                            <TableCell className={classes.tableHeaderCell} align="right">Total</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell className={classes.tableCell}>
                                    {row.skuMasterCode || ''}
                                </TableCell>
                                <TableCell className={classes.tableCell}>
                                    {row.skuCategoryName || ''}
                                </TableCell>
                                <TableCell className={classes.tableCell}>
                                    {row.skuMasterName || ''}
                                </TableCell> 
                                <TableCell className={classes.tableCell} align="right">
                                    {row.requestedQuantity ? row.requestedQuantity.toLocaleString(undefined, { minimumFractionDigits: 2 }) : '0.00'}
                                </TableCell> 
                                <TableCell className={classes.tableCell} align="right">
                                    {row.unitPrice ? row.unitPrice.toLocaleString(undefined, { minimumFractionDigits: 2 }) : '0.00'}
                                </TableCell> 
                                <TableCell className={classes.tableCell} align="right">
                {(() => {
                    const qty = row.requestedQuantity || 0;
                    const price = row.unitPrice || 0;
                    const rowTotal = qty * price;
                    return rowTotal.toLocaleString(undefined, { minimumFractionDigits: 2 });
                })()}
            </TableCell>
        
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Amount Section */}
            <Box className={classes.summaryBox}>
                <div className={classes.summaryRow}>
                    <span className={classes.summaryHeading}>Total Invoice Amount</span>
                </div>
                <div className={classes.summaryRow}>
                    <span className={classes.summaryLabel}>Total Payable:</span>
                    <span className={classes.summaryValue}>{grossTotal.toLocaleString(undefined, { minimumFractionDigits: 2 })}</span>
                </div> 
                <div className={classes.summaryRow}>
                    <span className={classes.summaryLabel}>Value Added Tax (VAT):</span>
                    <span className={classes.summaryValue}>{vat.toLocaleString(undefined, { minimumFractionDigits: 2 })}</span>
                </div>
                <div className={classes.summaryRow}>
                    <span className={classes.summaryLabel}>Net Amount Payable:</span>
                    <span className={classes.summaryValue}>{netTotal.toLocaleString(undefined, { minimumFractionDigits: 2 })}</span>
                </div>
            </Box>
            <div className={classes.bottom} style={{
                marginTop: '80px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                clear: 'both'
            }}>
                <Box className={classes.markBox}>
                    <div style={{ paddingTop: '10px' }}>
                        <strong>Entered By:</strong> {dpodetails.enterdBy || '-'}
                    </div> 
                    <div className={classes.signatureLine}>
                        <span className={classes.signatureText}>Name/Signature</span>
                    </div>
                </Box>
                <Box className={classes.markBox}>
                    <div style={{ paddingTop: '10px' }}>
                        <strong>Remark:</strong> {dpodetails.remark || '-'}
                    </div>
                </Box>
                <Box className={classes.markBox}> 
                    <div style={{ paddingTop: '10px' }}>
                        <strong>Checked By:</strong> {dpodetails.checkedBy || '-'}
                    </div>
                    <div className={classes.signatureLine}>
                        <span className={classes.signatureText}>Name/Signature</span>
                    </div>
                </Box>
            </div>
            
        </div>
    );
}